













import { listFactory } from '@/main/pages/listFactory';
// eslint-disable-next-line no-unused-vars
import { Cell } from '@/main/utils/table';

import { NAME } from './constants';
import { store } from './store/list';

export default listFactory(NAME, store).extend({
	computed: {
		useCreate() {
			return !!this.ZaznamId;
		},
	},
	methods: {
		currentChange(cells: Cell[]) {
			[this.ZaznamId] = cells;
		},
	},
});
